export default "__VITE_ASSET__CLbpKNZ9__"